module.exports = __webpack_public_path__ + "static/media/qr.49ef2de1.jpg";